import './app-edp.css';

import { onDomReady, onPageFullyLoaded } from '~/load-components';

document.addEventListener('DOMContentLoaded', onDomReady, false);
window.addEventListener('load', onPageFullyLoaded, false);
